export const AgbCodePrefix = {
    dentist: '12',
    generalPractitioner: '01',
    medicalSpecialist: '03',
    occupationalPhysician: '14',
    orthoptist: '44',
    otherPhysicians: '84',
} as const;
